import React, { FC } from 'react';

const Loader: FC<{ small?: boolean }> = ({ small }) => {
  return (
    <div data-testid="loader" className="centered">
      {!small && <div className="loader-spacer" />}
      <span className={small ? 'loader-small' : 'loader'} />
    </div>
  );
};

export default Loader;
